import React, { ButtonHTMLAttributes, FC } from 'react';

import { Button } from '../Button';
import { cn, ClassName } from '../../utils';
import styles from './index.module.scss';


export type CloseButtonProps = ClassName & ButtonHTMLAttributes<HTMLButtonElement> & {
    small?: boolean;
}

export const CloseButton: FC<CloseButtonProps> = ({
    className,
    small,
    ...props
}) => (
    <Button
        variant='auxiliary'
        className={cn(styles.closeButton, small && styles.small, className)}
        {...props}
    >
        <div className={styles.mark} />
    </Button>
);
